// © Microsoft Corporation. All rights reserved.

import { canUseDOM } from "@msnews/isomorphic-util";

const pageTimings = canUseDOM() ? (window._pageTimings || (window._pageTimings = {})) : null;

/**
 * Gets current window._pageTimings object
 */
export function getPageTimings(): object {
    return pageTimings;
}